<template>
    <div>
        <div class="row featured-item margin-lg-top" v-if="news">
            <div class="col-md-7">
                <router-link :to="newsPath(news)">
                    <img class="featured-img img-fluid"
                         v-lazy="news.image">
                </router-link>
            </div>
            <div class="col-md-5">
                <h4><router-link :to="newsPath(news)">{{news.title}}</router-link></h4>
                <p v-html="news.short"></p>
                <router-link :to="newsPath(news)"><span aria-hidden="true">&raquo;</span> {{ $t('button.ReadMore') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
  import newsMixin from '../../mixins/newsMixin';


  export default {
    name: 'LastFeaturedItem',
    props: ['lastFeaturedNews'],
    mixins: [newsMixin],
    computed: {
      news() {
        return this.lastFeaturedNews && this.lastFeaturedNews.data && this.lastFeaturedNews.data[0] ? this.lastFeaturedNews.data[0] : {}
      }
    }
  };
</script>

<style scoped>

</style>
